import {TrackingProduct} from '../../../types';
import {TrackingClientStateHolder} from '../helpers/clientState';
import {DataLayerEvent} from '../helpers/datalayer';

export const trackFitAnalytics =
  ({
    product,
    action,
    value,
  }: {
    product: TrackingProduct;
    action: 'start' | 'complete' | 'close' | 'update';
    value?: string;
  }) =>
  (clientState: TrackingClientStateHolder): DataLayerEvent => {
    if (value) {
      clientState.update({
        fitAnalyticsUsed: value,
      });
    }

    const event = {
      event: 'fitAnalytics',
      action: product.id,
      label: action,
      value: null,
    };

    return event;
  };
